import React from "react";
import { useNavigate } from "react-router-dom";
import { MCPServerManager } from "../components/MCPServerManager";

export const MCPServersView: React.FC = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1); // Go back to previous page
  };

  return (
    <div className="flex-1 overflow-hidden">
      <div className="h-full flex flex-col">
        {/* Header */}
        <div className="flex-shrink-0 p-6 border-b border-border-primary">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-white">MCP Servers</h1>
              <p className="text-gray-400 mt-1">Manage Model Context Protocol servers</p>
            </div>
            <button
              onClick={handleClose}
              className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors flex items-center gap-2"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
              Close
            </button>
          </div>
        </div>

        {/* MCP Server Manager Content */}
        <div className="flex-1 overflow-hidden">
          <MCPServerManager
            onClose={handleClose}
            className="h-full"
          />
        </div>
      </div>
    </div>
  );
};
